import { type Navigation, TemplateDetailsFactory } from '@domains/subscription'
import { TemplateTabs } from '@domains/subscription/priv/TemplateDetails/TemplateDetails'
import { createRoute } from '@domains/subscription/router/router'
import { type NavigateFunction, useNavigate, useParams } from 'react-router-dom'

export const TemplateDetailsPage = () => {
  const { templateId = '', tab = '', id = '' } = useParams<'templateId' | 'tab' | 'id'>()
  const navigate = useNavigate()

  return <TemplateDetailsFactory id={id} tab={tab} templateId={templateId} navigation={createNavigator({ templateId, navigate })} />
}

interface NavigatorParams {
  templateId: string
  navigate: NavigateFunction
}

// We want to replace when we navigate to a tab with a specific feature to avoid redundant history entries
const createNavigator = ({ templateId, navigate }: NavigatorParams): Navigation => ({
  back: () => {
    navigate(-1)
  },
  billableDetails: (billableId: string) => {
    navigate(createRoute.templateDetailsTabWithId({ templateId, tab: TemplateTabs.BILLABLES, id: billableId }), { replace: true })
  },
  featureDetails: (featureId: string) => {
    navigate(createRoute.templateDetailsTabWithId({ templateId, tab: TemplateTabs.FEATURES, id: featureId }), { replace: true })
  },
  tab: (tab: string) => {
    navigate(createRoute.templateDetailsTab({ templateId, tab }))
  },
})
